export const faqData = [
  {
    id: 1,
    question: 'Легальны ли онлайн казино в России?',
    answer: 'Онлайн казино с международными лицензиями (Кюрасао, Мальта) доступны для игроков из России. Важно выбирать проверенные площадки с хорошей репутацией и лицензией.'
  },
  {
    id: 2,
    question: 'Как быстро выводятся деньги из онлайн казино?',
    answer: 'Скорость вывода зависит от выбранного метода и казино. В топовых казино из нашего рейтинга вывод на карты российских банков и СБП занимает от 5 до 30 минут. Криптовалютные транзакции обрабатываются еще быстрее.'
  },
  {
    id: 3,
    question: 'Нужна ли верификация для игры в онлайн казино?',
    answer: 'Большинство казино требуют верификацию при первом выводе средств. Это стандартная процедура для предотвращения мошенничества. Некоторые казино позволяют играть без верификации при использовании криптовалют.'
  },
  {
    id: 4,
    question: 'Какие бонусы доступны новым игрокам?',
    answer: 'Новые игроки могут получить приветственные бонусы от 100% до 200% на первый депозит, а также бесплатные вращения (фриспины). Условия отыгрыша обычно составляют от x35 до x45.'
  },
  {
    id: 5,
    question: 'Можно ли играть в казино с мобильного телефона?',
    answer: 'Да, все современные онлайн казино оптимизированы для мобильных устройств. Многие предлагают специальные мобильные приложения для iOS и Android с полным функционалом.'
  },
  {
    id: 6,
    question: 'Какие методы пополнения доступны для игроков из России?',
    answer: 'Доступны карты российских банков (Visa, Mastercard, МИР), СБП, электронные кошельки (ЮMoney, Qiwi), криптовалюты (Bitcoin, Ethereum, USDT). Минимальный депозит обычно от 500 до 1000 рублей.'
  },
  {
    id: 7,
    question: 'Что такое RTP и как он влияет на выигрыш?',
    answer: 'RTP (Return to Player) — это процент возврата игроку. Например, RTP 96% означает, что из 100 поставленных рублей в среднем возвращается 96 рублей. Чем выше RTP, тем лучше для игрока.'
  },
  {
    id: 8,
    question: 'Безопасно ли играть в онлайн казино?',
    answer: 'Игра в лицензированных казино с SSL-шифрованием и хорошей репутацией безопасна. Мы рекомендуем выбирать казино из нашего рейтинга, которые прошли проверку на честность и надежность.'
  }
];